import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FilterAndSortButton = styled(Button)(({ theme }) => ({
  borderRadius: "var(--radius-sm, 8px)",
  height: "36px",
  minHeight: "36px",
  color: "var(--text, #98A2B3)",
  fontWeight: "500",
  border: "1px solid var(--border)",
  background: "var(--surface-2)",
  boxShadow: "var(--edge-hi)",
  textTransform: "none",
  fontSize: "13px",
  padding: "6px 13px",
  minWidth: "auto",
  gap: "6px",
  transition: "border-color 150ms, color 150ms, background-color 150ms, box-shadow 150ms",
  "& .MuiButton-startIcon": {
    margin: 0,
    marginRight: "4px",
  },
  "& svg": {
    width: "16px",
    height: "16px",
    fontSize: "16px",
    color: "var(--cyan)",
    transition: "color 150ms",
  },
  "&:hover": {
    borderColor: "var(--cyan)",
    color: "#fff",
    backgroundColor: "var(--surface-hi)",
    "& svg": {
      color: "var(--cyan)",
    },
  },
  "&.active, &[data-active='true']": {
    borderColor: "var(--cyan)",
    color: "#fff",
    backgroundColor: "var(--surface-hi)",
    boxShadow: "0 0 0 1px var(--cyan)",
    "& svg": {
      color: "var(--cyan)",
    },
  },
  [theme.breakpoints.down("md")]: {
    height: "34px",
    minHeight: "34px",
    padding: "4px 10px",
    fontSize: "12.5px",
    "& svg": {
      width: "15px",
      height: "15px",
      fontSize: "15px",
    },
  },
}));

export default FilterAndSortButton;
